export default "__VITE_ASSET__6dd21933__"